import fr from './locales/lang-fr'
import en from './locales/lang-en'
import { createI18n } from 'vue-i18n/dist/vue-i18n.cjs.js'

const i18n = createI18n({
  allowComposition: true,
  globalInjection: true,
  messages: {
    fr,
    en
  },
  silentTranslationWarn: true,
  fallbackLocale: 'fr'
})

export default i18n
